import { useTranslation } from 'react-i18next';
import { PRESET_NAMES, otherMedia } from '../../utils/cultureMedia';

/*
 * The <option>s of every culture-medium picker: the four standard media
 * first, as the options a picker opens on (utils/cultureMedia.js), then the
 * lab's other media from GET /protocols, each once. Goes inside the page's own
 * <select>, after its placeholder; `protocols` is that page's list (rows with
 * a name, or plain names). The value of every option is the medium's name,
 * as plates store it.
 */
export default function MediumOptions({ protocols }) {
  const { t } = useTranslation('common');
  const others = otherMedia(protocols);
  return (
    <>
      <optgroup label={t('media.standard')} data-testid="media-standard">
        {PRESET_NAMES.map((name) => <option key={`preset-${name}`} value={name}>{name}</option>)}
      </optgroup>
      {others.length > 0 && (
        <optgroup label={t('media.other')} data-testid="media-other">
          {others.map((p) => {
            const name = p?.name ?? p;
            return <option key={p?.protocol_id || name} value={name}>{name}</option>;
          })}
        </optgroup>
      )}
    </>
  );
}
